import { useEffect } from 'react';
import { checkQuizVisibility } from '../../../utils/check-quiz-visibility';
import { fetchQuizIndexData } from '../../../utils/fetch-quiz-index-data';
import { openQuiz } from '../../open-quiz-modal/open-quiz-modal';
import { checkConditions } from './check-conditions';
const DEFAULT_SESSION_VALUE = 'UXS_session_value';
/** Контролирует наличие квиза на странице, проверяет условия его показа и отправляет ивент об открытии */
export function useQuizTriggers(props) {
    const { url, user, sessionSecondsPassedKey = DEFAULT_SESSION_VALUE, environment = 'production' } = props;
    const userCurrentRoleType = user === null || user === void 0 ? void 0 : user.currentRoleType;
    const userId = user === null || user === void 0 ? void 0 : user.userId;
    useEffect(() => {
        let timeout;
        async function findQuizData() {
            const key = `${userId}_${url}`;
            const quizIndexData = await fetchQuizIndexData({ environment, key });
            const foundQuizData = quizIndexData.find(({ conditions }) => {
                return checkConditions({ conditions, url, userCurrentRoleType });
            });
            if (!foundQuizData || !(await checkQuizVisibility({ quizId: foundQuizData.id, userId }))) {
                return;
            }
            timeout = sendEventOpenQuiz({ quizData: foundQuizData, sessionSecondsPassedKey });
        }
        findQuizData();
        return () => {
            clearTimeout(timeout);
        };
    }, [url, userCurrentRoleType, userId, sessionSecondsPassedKey, environment]);
}
function sendEventOpenQuiz({ quizData, sessionSecondsPassedKey, }) {
    const eventData = { id: quizData.id, ...quizData.props };
    let timeout;
    if (!quizData.conditions.sessionTimeout) {
        openQuiz(eventData);
        return timeout;
    }
    const sessionTimeoutMilliseconds = quizData.conditions.sessionTimeout * 1000;
    const sessionMillisecondsPassed = quizData.conditions.isPageSessionTimeout
        ? 0
        : +sessionStorage.getItem(sessionSecondsPassedKey) * 1000;
    if (sessionTimeoutMilliseconds > sessionMillisecondsPassed) {
        timeout = setTimeout(() => {
            openQuiz(eventData);
        }, sessionTimeoutMilliseconds - sessionMillisecondsPassed);
    }
    else {
        openQuiz(eventData);
    }
    return timeout;
}
//# sourceMappingURL=use-quiz-triggers.js.map